<template>
  <div class="top">
    <div>
      <img src="../assets/404_road.svg" height="auto" alt />
    </div>
    <div class="passage-div">
      <p class="passage">Looks like you are lost!</p>
      <a href="#/">
        <button class="btn btn-outline-success highlight">Let's get back on Track</button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style>
.passage-div {
  margin: 20px;
}

.passage {
  font-size: 24px;
}

.top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 75px;
}

.top img {
  width: 90%;
  max-width: 800px;
  height: auto;
}

.highlight {
  font-size: 18px;
  color: black;
}

@media all and (max-width: 769px) {
  .passage-div {
    margin: 18px;
  }

  .passage {
    font-size: 24px;
  }

  .top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px;
  }

  .top img {
    width: 90%;
    height: auto;
  }

  .highlight {
    font-size: 16px;
    color: black;
  }
}

.passage a {
  color: #d00000;
}
</style>